export default __webpack_public_path__ + "static/media/chainlink.adbec545.svg";